import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TranslationRequestDto } from '@app/data/dtos/content-translator/content-translador.dto';
import {
  CONTENT_TRANSLATE_REPOSITORY,
  ContentTranslateRepository
} from '@app/domain/repositories/content-translate/content-translate.repository.contract';

import { ContentTranslateUseCases } from './content-translate.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class ContentTranslateUseCasesImpl implements ContentTranslateUseCases {
  #contentTranslateRepository: ContentTranslateRepository = inject(CONTENT_TRANSLATE_REPOSITORY);

  translate(translationRequest: TranslationRequestDto): Observable<string> {
    return this.#contentTranslateRepository.translate(translationRequest);
  }
}
